import TotalScoreCards from "./Components/TotalScoreCards";
import ActivityTable from "./Components/ActivityTable";

const SettingTabOrgBusiness = ({ obj, userId }) => {
  return (
    <div>
      <div>
        <TotalScoreCards obj={obj} />
        <ActivityTable obj={obj} userId={userId} />
      </div>
    </div>
  );
};

export default SettingTabOrgBusiness;
